export enum ThreePLProviderType {
  DeliverySolution = 'DeliverySolution',
  Uber = 'Uber',
  TrainIL = 'TrainIL',
  Contractor = 'Contractor',
  Wolt = 'Wolt'
}
